import { TranslationKeyWithParams } from 'constants/subscriptions';

import { ObjectValues } from 'helpers/types';

import { ICreatedUpdatedDates, IIdentifiable } from './common';

export const SUBSCRIPTION_PLAN = {
  UNAUTHORIZED: 'UNAUTHORIZED',
  FREE: 'FREE',
  STARTER: 'STARTER',
  LIGHT: 'LIGHT',
  STANDARD: 'STANDARD',
} as const;

export type ISubscriptionPlan = ObjectValues<typeof SUBSCRIPTION_PLAN>;

export const SUBSCRIPTION_RECURRENT = {
  MONTHLY: 'MONTHLY',
  ANNUALLY: 'ANNUALLY',
} as const;

export type ISubscriptionRecurrent = ObjectValues<typeof SUBSCRIPTION_RECURRENT>;

export const SUBSCRIPTION_STATUS = {
  CANCELLED_MANUALLY: 'CANCELED_MANUALLY',
  ACTIVE: 'ACTIVE',
} as const;

export type ISubscriptionStatus = ObjectValues<typeof SUBSCRIPTION_STATUS>;

export const SUBSCRIPTION_COLOR = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const;

export type ISubscriptionColor = ObjectValues<typeof SUBSCRIPTION_COLOR>;

export interface IUserSubscriptionEntity extends IIdentifiable, ICreatedUpdatedDates {
  subscriptionPlan: ISubscriptionPlan;
  recurrent: ISubscriptionRecurrent;
  email: string;
  endDate: number;
  status: ISubscriptionStatus;
  number: string;
}

export interface IUserSubscriptionResponse {
  currentSubscription: IUserSubscriptionEntity;
  nextSubscription: IUserSubscriptionEntity;
  hasActiveOrCompletedOrder: boolean;
}

export interface ISubscriptionItem {
  tariff: ISubscriptionPlan;
  title: string;
  detailsList: TranslationKeyWithParams[];
  monthlyPayment: number;
  annualPayment?: number;
}

export interface IMappedSubscriptionItem extends ISubscriptionItem {
  isCurrentPlan: boolean;
  isNextPlan: boolean;
  subscriptionRecurrent: ISubscriptionRecurrent;
  endDate: number;
  subscriptionStatus: ISubscriptionStatus | null;
  currentSubscriptionStatus: ISubscriptionStatus;
  color: ISubscriptionColor;
  nextSubscriptionPlan: ISubscriptionPlan;
  nextSubscriptionRecurrent: ISubscriptionRecurrent;
  isHasStandardOnLightTariff: boolean;
}

export interface ISubscriptionCheckoutBody {
  subscriptionPlan: string;
  recurrent: string;
}

export interface ISubscriptionPlanCard {
  tariff: ISubscriptionPlan;
  tariffTitle: string;
  tariffDescription1: string;
  tariffDescription2: string;
  billYearly: {
    tariffCostMonthly: string;
    tariffCostYearly: string;
    tariffCostMonthlyCrossed?: string;
  };
  billMonthly: {
    tariffCostMonthly: string;
    tariffCostYearly: string;
    tariffCostMonthlyCrossed?: string;
  };
  tariffFeatures: TranslationKeyWithParams[];
}
